import { ACTION_TYPE } from "./type";
// import { login } from '../../utilities/api'
import Config from "../../utilities/config";
import { store } from "../store";
import {
  home_product_type_count,
  homeNotification,
  homeResponse,
  subscribeUser,
  submitContactForm,
  filter_product_suggestion,
  dailyMetalPriceAndCurrency,
  cdnresponse,
} from "../../utilities/api";
import constants from "../../utilities/constants";
import {
  createHomeDataResponseObject,
  createHomeProductCountObject,
  instagramResponseObject,
} from "../../utilities/helper";
import { Toast } from "../../components/Atoms/Toast";
import config from "../../utilities/config";

//Login
// export const loginUser = (form_data) => async (dispatch) => {
//     dispatch({ type: ACTION_TYPE.LOGIN_USER_ATTEMPT });

//     try {
//         // const  data  = await login(form_data);
//         const data="123"
//         dispatch({
//             type: ACTION_TYPE.LOGIN_USER_SUCCESS,
//             loginStatus:true,
//             payload: data
//         });
//     } catch (error) {
//         config.logGeneral && console.log("Error", error)
//         dispatch({ type: ACTION_TYPE.LOGIN_USER_FAIL, errorMessage: error?.response?.data?.message, loginStatus:error?.response? error.response.data.status:error.message});
//     }
// };

// export const logout = () => async (dispatch) => {

//     dispatch({ type: ACTION_TYPE.USER_LOGGED_OUT });
// };

// export const loginInitLoading = () => async (dispatch) => {
//     dispatch({ type: ACTION_TYPE.LOGIN_INIT_LOADING,errorMessage:null });
// };

// export const update_token_fun=(update_token)=>(dispatch)=>{

//     dispatch({ type: ACTION_TYPE.LOGIN_UPDATE_TOKEN,token:{update_token} });

// }

const instagramLinksData = [
  { url: "https://www.instagram.com/p/CHxHtszjay_" },
  { url: "https://www.instagram.com/p/CgUJ_YkM0eb" },
  { url: "https://www.instagram.com/p/CftPxp-sT8T" },
  { url: "https://www.instagram.com/p/CeJCf1GviD7" },
  { url: "https://www.instagram.com/p/Cfd-xqgPxJ5" },
];
const menuListHeaderNew1 = [
  {
    title: "Wedding Ensemble",
    key: "1",
    isLink: true,
    url: "/silver-jewellery-wedding+ensemble?sort=New%20to%20Stylori&startprice=0&endprice=0",
    // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
     Submenu: [
      [
        {
          value: null,
          img: constants.DEFAULT_IMAGE + "/silver-wedding-collection.jpg",
          description:
            "Grace your wedding day with timeless silver. Crafted in Certified 925 silver, each piece adds elegance and sparkle to complete your perfect bridal ensemble.",
          title: "WEDDING ENSEMBLE",
          url: "/silver-jewellery-wedding+ensemble?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
          button: "Explore Our New Arrivals",
          button_url:"/silver-jewellery-wedding+ensemble?sort=New%20to%20Stylori&startprice=0&endprice=0"
        },
        // {value:"TOP 20 NECKLACES",
        // title: "TOP 20 NECKLACES",
        // url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // }
      ],
      [
        {
          value: null,
          title: "CATEGORIES",
          url: "/silver-jewellery-wedding+ensemble?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
        },
        {
          value: "Muhurtham",
          title: null,
          isLink: true,
          url: "/silver-muhurtham-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Haldi",
          title: null,
          url: "/silver-haldi-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Sangeet/Mehendi",
          title: null,
          url: "/silver-sangeet+mehandi-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Reception",
          title: null,
          url: "/silver-reception-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: null,
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-studded+jewellery-wed?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        
        {
          value: null,
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-nagas+nakshi-wed?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: null,
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-dual+tone+finish-wed?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: null,
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-victorian-wed?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: null,
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-oxidised+finish-wed?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: null,
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-finish+others-wed?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
    ],
    expand: true,
  },
  {
    title: "Necklaces",
    key: "2",
    url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    Submenu: [
      [
        {
          value: null,
          img: constants.DEFAULT_IMAGE + "/menu-title-necklace-model.jpg",
          description:
            "Explore our curated collection of silver necklaces where every design, from statement chokers to vintage-inspired pieces, brings together tradition, artistry, and modern charm.",
          title: "NECKLACES",
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
          button: "Explore Our New Arrivals",
          button_url:"/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        },
        // {value:"TOP 20 NECKLACES",
        // title: "TOP 20 NECKLACES",
        // url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // }
      ],
      [
        {
          value: null,
          title: "FINISH AND DESIGN",
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
        },
        {
          value: "CZ/Swarovski Jewellery",
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Beads & Pearl Jewellery",
          title: null,
          url: "/silver-necklaces-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Deep Nagas & Kundan",
          title: null,
          url: "/silver-necklaces-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Gold Plated Kundan",
          title: null,
          url: "/silver-necklaces-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Studded Jewellery",
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   value: "Gold Plated kemp",
        //   title: "Gold Plated kemp",
        //   url: "/silver-necklaces-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // },
        {
          value: "Nagas/Nakshi",
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Dual Tone",
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Victorian",
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Oxidised",
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Others",
          title: null,
          isLink: true,
          url: "/silver-necklaces-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      [
        {
          value: null,
          title: "JEWEL TYPE",
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
        },
        {
          value: "Short Necklace",
          title: null,
          isLink: true,
          url: "/short+necklace-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Long Necklace",
          title: null,
          isLink: true,
          url: "/long+necklace-silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Necklace And Earrings(Set)",
          title: null,
          isLink: true,
          url: "/short+necklace-silver-set-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Choker",
          title: null,
          isLink: true,
          url: "/silver-chokers-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Gutta Pusalu",
          title: null,
          isLink: true,
          url: "/silver-guttapusalu+necklace-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Kaasu Maalai",
          isLink: true,
          title: null,
          url: "/silver-kasumalai+necklace-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Layered",
          isLink: true,
          title: null,
          url: "/silver-layered+necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Beads/ Chain",
          isLink: true,
          title: null,
          url: "/silver-necklaces-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      [
        {
          title: "PRICE RANGE",
          isLink: true,
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Under 5000",
          isLink: true,
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=5000",
        },
        {
          value: "5000-10000",
          isLink: true,
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=5001&endprice=10000",
        },
        {
          value: "10000-25000",
          isLink: true,
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
        },
        {
          value: "Above 25000",
          isLink: true,
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=25001&endprice=100000000",
        },
        
        {
          title: "STYLE",
          value: null,
          isLink: false,
          url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck style-title custom-spacing-top",
        },
        {
          title: null,
          value: "Traditional",
          isLink: true,
          url: "/silver-necklaces-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          title: null,
          isLink: true,
          value: "Folklore",
          url: "/silver-necklaces-jewellery-folklore?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Contemporary",
          isLink: true,
          url: "/silver-necklaces-jewellery-contemporary?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {"title":"Dmudra","value":"Dmudra","url":"/silver-jewellery-dmudra?sort=New%20to%20Stylori&startprice=0&endprice=0"},
        {
          title: null,
          value: "Everyday",
          isLink: true,
          url: "/silver-necklaces-jewellery-everyday?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
    ],
    expand: true,
  },

  {
    title: "Earrings",
    key: "3",
    url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    Submenu: [
      [
        {
          value: null,
          description:
            "From festive favourites to everyday elegance, our collection of silver bangles includes Kundan, Kemp, nakshi, and Victorian designs crafted as single pieces or beautiful pairs.",
          img: constants.DEFAULT_IMAGE + "/menu-title-earing-model.jpg",
          title: "EARRINGS",
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          isLink: true,
          button: "Explore Our New Arrivals",
          button_url:"/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        },
        // {value:"TOP 20 EARRINGS",
        // title: "TOP 20 EARRINGS",
        // url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // }
      ],
      [
        {
          title: "FINISH AND DESIGN",
          value: null,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          isLink: false,
        },
        {
          title: null,
          value: "CZ/Swarovski Jewellery",
          isLink: true,
          url: "/earrings-silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Beads & Pearl Jewellery",
          isLink: true,
          url: "/earrings-silver-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Deep Nagas & Kundan",
          isLink: true,
          url: "/earrings-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Gold Plated Kundan",
          isLink: true,
          url: "/earrings-silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Studded Jewellery",
          isLink: true,
          url: "/earrings-silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // { title: "Gold Plated kemp", value: "Gold Plated kemp", url: "/earrings-silver-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0" },
        {
          title: null,
          value: "Nagas/Nakshi",
          isLink: true,
          url: "/earrings-silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // { title: "Rose Gold", value: "Rose Gold", url: "/earrings-silver-jewellery-rose+gold+finish?sort=New%20to%20Stylori&startprice=0&endprice=0" },
        {
          title: null,
          value: "Dual Tone",
          isLink: true,
          url: "/earrings-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Victorian",
          isLink: true,
          url: "/earrings-silver-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Oxidised",
          isLink: true,
          url: "/earrings-silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Others",
          isLink: true,
          url: "/others-earrings-silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      [
        {
          title: "JEWEL TYPE",
          value: null,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          isLink: false,
        },
        {
          title: null,
          value: "Studs",
          isLink: true,
          url: "/earrings-silver-studs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Jhumkas",
          isLink: true,
          url: "/earrings-silver-jhumkas+online-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Long Earrings/Drops",
          isLink: true,
          url: "/silver-long+earrings+drops-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Hooks & Hoops",
          isLink: true,
          url: "/earrings-silver-hooks+hoops-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   title: null,
        //   value: "Gutta Pusalu",
        //   url: "/silver-earrings-guttapusalu-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        // {
        //   title: null,
        //   value: "Ear cuffs",
        //   url: "/earrings-silver-ear+cuffs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        {
          title: null,
          value: "Chandbali",
          isLink: true,
          url: "/earrings-silver-chandbali-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Cocktail Earrings",
          isLink: false,
          url: "/cocktail-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      [
        { title: "PRICE RANGE", isLink: false, url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0", class: "allneck" },
        {
          value: "Under 5000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=5000",
        },
        {
          value: "5000-10000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=Price%20Low%20to%20High&startprice=5001&endprice=10000",
        },
        {
          value: "10000-25000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
        },
        {
          value: "Above 25000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=Price%20Low%20to%20High&startprice=25001&endprice=25000000",
        },
      ],
    ],
    expand: true,
  },
  {
    title: "Bangles",
    key: "4",
    url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    Submenu: [
      [
        {
          value: null,
          title: "BANGLES",
          img: constants.DEFAULT_IMAGE + "/menu-title-bangle-model.jpg",
          isLink: true,
          description:
            "Elevate every look with silver earrings in classic styles like jhumkas, chandbalis, guttapusalu, drops, and studs. Each pair is designed to add grace and charm effortlessly.",
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          button: "Explore Our New Arrivals",
          button_url:"/silver-wristwear-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        },
      ],
      [
        {
          title: "FINISH AND DESIGN",
          value: null,
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          title: null,
          isLink: true,
          value: "CZ/Swarovski Jewellery",
          url: "/bangles-silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   title: null,
        //   isLink: true,
        //   value: "Beads & Pearl Jewellery",
        //   url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        {
          title: null,
          isLink: true,
          value: "Deep Nagas & Kundan",
          url: "/bangles-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          isLink: true,
          value: "Gold Plated Kundan",
          url: "/bangles-silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          isLink: true,
          value: "Studded Jewellery",
          url: "/bangles-silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          isLink: true,
          value: "Nagas/Nakshi",
          url: "/bangles-silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Dual Tone",
          isLink: true,
          url: "/bangles-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Victorian",
          isLink: true,
          url: "/bangles-silver-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Oxidised",
          isLink: true,
          url: "/bangles-silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Others",
          isLink: true,
          url: "/others-bangles-silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      [
        {
          title: "JEWEL TYPE",
          value: null,
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          title: null,
          value: "Single Bangle",
          isLink: true,
          url: "/silver-single+bangle-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Pair Bangle",
          isLink: true,
          url: "/silver-pair+bangle-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Bracelet",
          isLink: true,
          url: "/bracelets-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      [
        {
          title: "PRICE RANGE",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=200000",
          class: "allneck",
        },
        {
          value: "Under 5000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=5000",
        },
        {
          value: "5000-10000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=5001&endprice=10000",
        },
        {
          value: "10000-25000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
        },
        {
          value: "Above 25000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=25001&endprice=10000000",
        },
      ],
    ],
    expand: true,
  },
  // {
  //   title: "Pendants",
  //   key: "4",
  //   url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //   // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
  //   Submenu: [
  //     [
  //       {
  //         value: null,
  //         title: "ALL PENDANTS",
  //         img: constants.DEFAULT_IMAGE + "/nacklace.jpg",
  //         description:
  //           "Discover our exquisite collection of necklaces tailored for every style, material, and occasion. From timeless gold pieces to dazzling diamonds, explore the perfect accessory to complement your look",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //         button: "Explore Our New Arrivals",
  //       },
  //       // {value:"TOP 20 PENDANTS",
  //       // title: "TOP 20 PENDANTS",
  //       // url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
  //       // }
  //     ],
  //     [
  //       {
  //         title: "FINISH AND DESIGN",
  //         value: null,
  //         url: "#",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "CZ/Swarovski Jewellery",
  //         url: "/pendants-silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Deep Nagas & Kundan",
  //         url: "/pendants-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Gold Plated Kundan",
  //         url: "/pendants-silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Studded Jewellery",
  //         url: "/pendants-silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       // { title: "Gold Plated kemp", value: "Gold Plated kemp", url: "/pendants-silver-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0" },
  //       {
  //         title: null,
  //         value: "Nagas/Nakshi",
  //         url: "/pendants-silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       // { title: "Rose Gold", value: "Rose Gold", url: "/pendants-silver-jewellery-rose+gold+finish?sort=New%20to%20Stylori&startprice=0&endprice=0" },
  //       {
  //         title: null,
  //         value: "Dual Tone",
  //         url: "/pendants-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Victorian",
  //         url: "/pendants-silver-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Oxidised",
  //         url: "/pendants-silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Others",
  //         url: "/others-pendants-silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //     [
  //       {
  //         title: "JEWEL TYPE",
  //         value: null,
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Pendant & Earring",
  //         url: "/silver-pendant+earring-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Double Hook",
  //         url: "/silver-doublehook-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Single Hook",
  //         url: "/silver-singlehook-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //     [
  //       {
  //         title: "PRICE RANGE",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=200000",
  //         class: "allneck",
  //       },
  //       {
  //         value: "Under 5000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=5000",
  //       },
  //       {
  //         value: "5000-10000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=5001&endprice=10000",
  //       },
  //       {
  //         value: "10000-25000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
  //       },
  //       {
  //         value: "Above 25000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=25001&endprice=200000",
  //       },
  //     ],
  //   ],
  //   expand: true,
  // },
  // [
  //   { title: "MORE CATEGORIES", value: "MORE CATEGORIES", url: "#" },
  //   { title: "Hair Ornaments", value: "Hair Ornaments", url: "#" },
  //   { title: "Idols & Articles", value: "Idols & Articles", url: "#" },
  //   { title: "Maang Tikka", value: "Maang Tikka", url: "#" },
  //   { title: "Oddiyanam", value: "Oddiyanam", url: "#" },
  //   { title: "Bracelet", value: "Bracelet", url: "#" },
  //   { title: "Armlets", value: "Armlets", url: "#" },
  //   { title: "Anklets", value: "Anklets", url: "#" },
  //   { title: "Nosepin", value: "Nosepin", url: "#" },
  //   { title: "Other Accessories", value: "Other Accessories", url: "#" }
  // ]
  //wedding collections

  {
    title: "Others Categories",
    key: "5",
    url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
    Submenu: [
      [
        {
          value: null,
          title: "OTHERS",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Pendant",
          title: null,
          url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
        },
        {
          value: "Ring",
          title: null,
          isLink: true,
          url: "/rings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Maang Tikka",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-maang+tikka-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Oddiyanam",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-oddiyanam-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Armlet",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-armlet-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Hair Ornaments",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-hair+ornaments-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Nosepin",
          title: null,
          isLink: true,
          url: "/nose+pin+online-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Anklets",
          title: null,
          isLink: true,
          url: "/anklet-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Idols",
          title: null,
          isLink: true,
          url: "/idols-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Mens Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-from+mens+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Others",
          title: null,
          isLink: true,
          url: "/others-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
      //Gifting
      [
        {
          title: "GIFTING",
          value: null,
          isLink: false,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          title: null,
          value: "Under 1499",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=1500",
          class: "allneck",
        },
        {
          title: null,
          isLink: true,
          value: "Under 2499",
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=1500&endprice=2500",
        },
        {
          title: null,
          value: "Under 4999",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=2500&endprice=5000",
        },
        // {"title":"Dmudra","value":"Dmudra","url":"/silver-jewellery-dmudra?sort=New%20to%20Stylori&startprice=0&endprice=0"},
        {
          title: null,
          value: "Under 9999",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=5000&endprice=10000",
        },
      ],
      //finish
      [
        {
          value: null,
          title: "FINISH",
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: false,
          class: "allneck",
        },
        {
          value: "CZ/Swarovski Jewellery",
          title: null,
          isLink: true,
          url: "/silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Beads & Pearl Jewellery",
          title: null,
          url: "/silver-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Deep Nagas & Kundan",
          title: null,
          url: "/silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Gold Plated Kundan",
          title: null,
          url: "/silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Studded Jewellery",
          title: null,
          isLink: true,
          url: "/silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   value: "Gold Plated kemp",
        //   title: "Gold Plated kemp",
        //   url: "/silver-necklaces-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // },
        {
          value: "Nagas/Nakshi",
          title: null,
          isLink: true,
          url: "/silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Dual Tone",
          isLink: true,
          title: null,
          url: "/silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Victorian",
          isLink: true,
          title: null,
          url: "/silver-jewellery-victorian-finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Oxidised",
          isLink: true,
          title: null,
          url: "/silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Others",
          title: null,
          isLink: true,
          url: "/silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
    ],
    expand: true,
  },
  // {
  //   title: "Style",
  //   key: "6",
  //   isLink: true,
  //   url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //   Submenu: [
  //     [
  //       {
  //         title: "Style",
  //         value: null,
  //         isLink: true,
  //         url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Traditional",
  //         isLink: true,
  //         url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         isLink: true,
  //         value: "Folklore",
  //         url: "/silver-jewellery-folklore?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Contemporary",
  //         isLink: true,
  //         url: "/silver-jewellery-contemporary?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       // {"title":"Dmudra","value":"Dmudra","url":"/silver-jewellery-dmudra?sort=New%20to%20Stylori&startprice=0&endprice=0"},
  //       {
  //         title: null,
  //         value: "Everyday",
  //         isLink: true,
  //         url: "/silver-jewellery-everyday?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //   ],
  //   expand: true,
  // },
  // {
  //   title: "Shop By Collection",
  //   key: "7",
  //   url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //   Submenu: [
  //     [
  //       {
  //         title: "SHOP BY COLLECTION",
  //         value: null,
  //         url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Rasvini",
  //         url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Mural",
  //         url: "/silver-jewellery-mural+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Starstuck",
  //         url: "/silver-jewellery-starstruck+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Concentric",
  //         url: "/silver-jewellery-concentric+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "IN LOVE COLLECTION",
  //         url: "/silver-jewellery-inlovecollection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Elemental",
  //         url: "/silver-jewellery-elemental+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Baroque Whites",
  //         url: "/silver-jewellery-baroque+whites+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Akruti",
  //         url: "/silver-jewellery-akruti+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //   ],
  //   expand: true,
  // },
  {
    title: "Hot Sale",
    key: "6",
    isLink: true,
    url: "/silver-special+offer+sale-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",

    expand: false,
  },
  // {
  //   title: "Stylori",
  //   key: "8",
  //   url: "/",
  //   expand: false
  // }
  {
    title: "Collection",
    key: "7",
    isLink: true,
    url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
    Submenu: [
      [
        {
          value: null,
          title: "Collection",
          isLink: false,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Avarna",
          title: null,
          isLink: false,
          url: "/silver-jewellery-avarna?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Zelura",
          title: null,
          isLink: false,
          url: "/silver-jewellery-zelura?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Rasvini",
          isLink: false,
          title: null,
          url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "InLove",
          title: null,
          isLink: false,
          url: "/silver-jewellery-inlovecollection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Victorian",
          title: null,
          isLink: false,
          url: "/silver-jewellery-victorian-collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Mural Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-mural+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Elemental Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-elemental+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Akruti Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-akruti+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   value: "Mens Collection",
        //   title: null,
        //   isLink: false,
        //   url: "/silver-jewellery-from+mens+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        // {
        //   value: "Bridal",
        //   title: null,
        //   isLink: false,
        //   url: "/silver-jewellery-for+wedding?sort=New%20to%20Stylori&startprice=0&endprice=0"          
        // },
      ],
    ],
    expand: true,
  },
];
const menuListHeaderNew1mobile = [
  {
    title: "Wedding Ensemble",
    key: "4",
    isLink: true,
    url: "/silver-jewellery-wedding+ensemble?sort=New%20to%20Stylori&startprice=0&endprice=0",
    // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
    Submenu: [
      [
        // {
        //   value: null,
        //   title: "WEDDING ENSEMBLE",
        //   isLink: true,
        //   url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        //   class: "allneck",
        // },
        {
          value: "Muhurtham",
          title: null,
          isLink: false,
          url: "/silver-muhurtham-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",          
          class: "allneck",
        },
        {
          value: "Haldi",
          isLink: false,
          title: null,
          url: "/silver-haldi-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",          
        },
        {
          value: "Sangeet/Mehendi",
          title: null,
          isLink: false,
          // url: "/silver-jewellery-sangeet+mehandi?sort=New%20to%20Stylori&startprice=0&endprice=0",
          url:"/silver-sangeet+mehandi-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
        },
        {
          value: "Reception",
          title: null,
          isLink: false,
          url: "/silver-reception-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
      ],
    ],
    expand: true,
  },
  {
    title: "Necklaces",
    key: "1",
    url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    Submenu: [
      // [
      //   {
      //     value: null,
      //     img: constants.DEFAULT_IMAGE + "/menu-title-necklace-model.jpg",
      //     description:
      //       "These necklaces bring instant charm and effortless style to every look. Explore pieces that are chic, trendy, and crafted to be your go-to accessory, because life's too short to wear boring jewellery!",
      //     title: null,
      //     url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
      //     isLink: true,
      //     class: "allneck",
      //     button: "Explore Our New Arrivals",
      //     button_url:
      //       "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
      //   },
      //   {value:"TOP 20 NECKLACES",
      //   title: "TOP 20 NECKLACES",
      //   url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
      //   }
      // ],
      [
        {
          value: null,
          title: "NECKLACES FINISH AND DESIGN",
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
          subitems: [
            {
              value: "CZ/Swarovski Jewellery",
              title: null,
              isLink: true,
              url: "/silver-necklaces-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Beads & Pearl Jewellery",
              title: null,
              url: "/silver-necklaces-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
              isLink: true,
            },
            {
              value: "Deep Nagas & Kundan",
              title: null,
              url: "/silver-necklaces-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
              isLink: true,
            },
            {
              value: "Gold Plated Kundan",
              title: null,
              url: "/earrings-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
              isLink: true,
            },
            {
              value: "Studded Jewellery",
              title: null,
              isLink: true,
              url: "/silver-necklaces-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            // {
            //   value: "Gold Plated kemp",
            //   title: "Gold Plated kemp",
            //   url: "/silver-necklaces-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0"
            // },
            {
              value: "Nagas/Nakshi",
              title: null,
              isLink: true,
              url: "/silver-necklaces-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Dual Tone",
              isLink: true,
              title: null,
              url: "/silver-necklaces-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Victorian",
              isLink: true,
              title: null,
              url: "/silver-necklaces-jewellery-victorian-necklaces?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Oxidised",
              isLink: true,
              title: null,
              url: "/silver-necklaces-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Others",
              title: null,
              isLink: true,
              url: "/silver-necklaces-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
          ],
        },
      ],
      [
        {
          value: null,
          title: "JEWEL TYPE",
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
          subitems: [
            {
              value: "Short Necklace",
              title: null,
              isLink: true,
              url: "/short+necklace-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Long Necklace",
              title: null,
              isLink: true,
              url: "/long+necklace-silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Necklace And Earrings(Set)",
              title: null,
              isLink: true,
              url: "/short+necklace-silver-set-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Choker",
              title: null,
              isLink: true,
              url: "/silver-chokers-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Gutta Pusalu",
              title: null,
              isLink: true,
              url: "/silver-guttapusalu+necklace-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Kaasu Maalai",
              isLink: true,
              title: null,
              url: "/silver-kasumalai+necklace-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Layered",
              isLink: true,
              title: null,
              url: "/silver-layered+necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "Beads/ Chain",
              isLink: true,
              title: null,
              url: "/silver-necklaces-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
          ],
        },
      ],
      [
        {
          title: "PRICE RANGE",
          isLink: true,
          url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=200000",
          class: "allneck",
          subitems: [
            {
              value: "Under 5000",
              isLink: true,
              url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
            },
            {
              value: "5000-10000",
              isLink: true,
              url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=5001&endprice=10000",
            },
            {
              value: "10000-25000",
              isLink: true,
              url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
            },
            {
              value: "Above 25000",
              isLink: true,
              url: "/silver-necklaces-jewellery?sort=New%20to%20Stylori&startprice=25001&endprice=100000000",
            },

            
          ],
        },
        
      ],
      [
        {
          title: "STYLE",
          value: null,
          isLink: false,
          url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck style-title custom-spacing-top",
          subitems: [
            {
          title: null,
          value: "Traditional",
          isLink: true,
          url: "/silver-necklaces-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          title: null,
          isLink: true,
          value: "Folklore",
          url: "/silver-necklaces-jewellery-folklore?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Contemporary",
          isLink: true,
          url: "/silver-necklaces-jewellery-contemporary?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {"title":"Dmudra","value":"Dmudra","url":"/silver-jewellery-dmudra?sort=New%20to%20Stylori&startprice=0&endprice=0"},
        {
          title: null,
          value: "Everyday",
          isLink: true,
          url: "/silver-necklaces-jewellery-everyday?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },

            
          ],
        },
        
      ],
    ],
    expand: true,
  },

  {
    title: "Earrings",
    key: "2",
    url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    Submenu: [
      // [
      //   {
      //     value: null,
      //     description:
      //       "From subtle studs to statement danglers, our silver earring collection is all about effortless glam. These pieces add that perfect finishing touch to every outfit. Whether you're keeping it casual or going all out, there's a sparkle here for every mood, every moment",
      //     img: constants.DEFAULT_IMAGE + "/menu-title-earing-model.jpg",
      //     title: "EARRINGS",
      //     url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
      //     class: "allneck",
      //     isLink: true,
      //     button: "Explore Our New Arrivals",
      //     button_url:
      //       "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
      //   },
      //   {value:"TOP 20 EARRINGS",
      //   title: "TOP 20 EARRINGS",
      //   url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
      //   }
      // ],
      [
        {
          title: "EARRINGS FINISH AND DESIGN",
          value: null,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          isLink: false,
          subitems:[
            {
          title: null,
          value: "CZ/Swarovski Jewellery",
          isLink: true,
          url: "/earrings-silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Beads & Pearl Jewellery",
          isLink: true,
          url: "/earrings-silver-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Deep Nagas & Kundan",
          isLink: true,
          url: "/earrings-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Gold Plated Kundan",
          isLink: true,
          url: "/earrings-silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Studded Jewellery",
          isLink: true,
          url: "/earrings-silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // { title: "Gold Plated kemp", value: "Gold Plated kemp", url: "/earrings-silver-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0" },
        {
          title: null,
          value: "Nagas/Nakshi",
          isLink: true,
          url: "/earrings-silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // { title: "Rose Gold", value: "Rose Gold", url: "/earrings-silver-jewellery-rose+gold+finish?sort=New%20to%20Stylori&startprice=0&endprice=0" },
        {
          title: null,
          value: "Dual Tone",
          isLink: true,
          url: "/earrings-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Victorian",
          isLink: true,
          url: "/earrings-silver-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Oxidised",
          isLink: true,
          url: "/earrings-silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Others",
          isLink: true,
          url: "/others-earrings-silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
          ]
        },
        
      ],
      [
        {
          title: "JEWEL TYPE",
          value: null,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          subitems:[{
          title: null,
          value: "Studs",
          isLink: true,
          url: "/earrings-silver-studs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Jhumkas",
          isLink: true,
          url: "/earrings-silver-jhumkas+online-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Long Earrings/Drops",
          isLink: true,
          url: "/silver-long+earrings+drops-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Hooks & Hoops",
          isLink: true,
          url: "/earrings-silver-hooks+hoops-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   title: null,
        //   value: "Gutta Pusalu",
        //   url: "/silver-earrings-guttapusalu-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        // {
        //   title: null,
        //   value: "Ear cuffs",
        //   url: "/earrings-silver-ear+cuffs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        {
          title: null,
          value: "Chandbali",
          isLink: true,
          url: "/earrings-silver-chandbali-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Cocktail Earrings",
          isLink: false,
          url: "/cocktail-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        }],
          isLink: false,
        },
        
      ],
      [
        { title: "PRICE RANGE", isLink: false, url: "#", class: "allneck",
          subitems:[{
          value: "Under 5000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "5000-10000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=Price%20Low%20to%20High&startprice=5001&endprice=10000",
        },
        {
          value: "10000-25000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
        },
        {
          value: "Above 25000",
          isLink: true,
          url: "/earrings-silver-jewellery?sort=Price%20Low%20to%20High&startprice=25001&endprice=25000000",
        }]
         },
        
      ],
    ],
    expand: true,
  },
  {
    title: "Bangles",
    key: "3",
    url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    Submenu: [
      // [
      //   {
      //     value: null,
      //     title: "BANGLES",
      //     img: constants.DEFAULT_IMAGE + "/menu-title-bangle-model.jpg",
      //     isLink: true,
      //     description:
      //       "Grace your wrists with silver bangles crafted for the moments worth celebrating",
      //     url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
      //     class: "allneck",
      //     button: "Explore Our New Arrivals",
      //     button_url:
      //       "/silver-wristwear-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
      //   },
      // ],
      [
        {
          title: "BANGLES FINISH AND DESIGN",
          value: null,
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          subitems:[
            {
          title: null,
          isLink: true,
          value: "CZ/Swarovski Jewellery",
          url: "/bangles-silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   title: null,
        //   isLink: true,
        //   value: "Beads & Pearl Jewellery",
        //   url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        {
          title: null,
          isLink: true,
          value: "Deep Nagas & Kundan",
          url: "/bangles-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          isLink: true,
          value: "Gold Plated Kundan",
          url: "/bangles-silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          isLink: true,
          value: "Studded Jewellery",
          url: "/bangles-silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          isLink: true,
          value: "Nagas/Nakshi",
          url: "/bangles-silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Dual Tone",
          isLink: true,
          url: "/bangles-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Victorian",
          isLink: true,
          url: "/bangles-silver-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Oxidised",
          isLink: true,
          url: "/bangles-silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Others",
          isLink: true,
          url: "/others-bangles-silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
          ],
          class: "allneck",
        },
        
      ],
      [
        {
          title: "JEWEL TYPE",
          value: null,
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          subitems:[{
          title: null,
          value: "Single Bangle",
          isLink: true,
          url: "/silver-single+bangle-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Pair Bangle",
          isLink: true,
          url: "/silver-pair+bangle-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          title: null,
          value: "Bracelet",
          isLink: true,
          url: "/bracelets-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        }]
        },
        
      ],
      [
        {
          title: "PRICE RANGE",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          subitems:[
            {
          value: "Under 5000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=5000",
        },
        {
          value: "5000-10000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=5001&endprice=10000",
        },
        {
          value: "10000-25000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
        },
        {
          value: "Above 25000",
          isLink: true,
          url: "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=25001&endprice=10000000",
        }
          ]
        },
        
      ],
    ],
    expand: true,
  },
  // {
  //   title: "Pendants",
  //   key: "4",
  //   url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //   // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
  //   Submenu: [
  //     [
  //       {
  //         value: null,
  //         title: "ALL PENDANTS",
  //         img: constants.DEFAULT_IMAGE + "/nacklace.jpg",
  //         description:
  //           "Discover our exquisite collection of necklaces tailored for every style, material, and occasion. From timeless gold pieces to dazzling diamonds, explore the perfect accessory to complement your look",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //         button: "Explore Our New Arrivals",
  //       },
  //       // {value:"TOP 20 PENDANTS",
  //       // title: "TOP 20 PENDANTS",
  //       // url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
  //       // }
  //     ],
  //     [
  //       {
  //         title: "FINISH AND DESIGN",
  //         value: null,
  //         url: "#",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "CZ/Swarovski Jewellery",
  //         url: "/pendants-silver-jewellery-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Deep Nagas & Kundan",
  //         url: "/pendants-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Gold Plated Kundan",
  //         url: "/pendants-silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Studded Jewellery",
  //         url: "/pendants-silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       // { title: "Gold Plated kemp", value: "Gold Plated kemp", url: "/pendants-silver-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0" },
  //       {
  //         title: null,
  //         value: "Nagas/Nakshi",
  //         url: "/pendants-silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       // { title: "Rose Gold", value: "Rose Gold", url: "/pendants-silver-jewellery-rose+gold+finish?sort=New%20to%20Stylori&startprice=0&endprice=0" },
  //       {
  //         title: null,
  //         value: "Dual Tone",
  //         url: "/pendants-silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Victorian",
  //         url: "/pendants-silver-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Oxidised",
  //         url: "/pendants-silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Others",
  //         url: "/others-pendants-silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //     [
  //       {
  //         title: "JEWEL TYPE",
  //         value: null,
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Pendant & Earring",
  //         url: "/silver-pendant+earring-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Double Hook",
  //         url: "/silver-doublehook-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Single Hook",
  //         url: "/silver-singlehook-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //     [
  //       {
  //         title: "PRICE RANGE",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=200000",
  //         class: "allneck",
  //       },
  //       {
  //         value: "Under 5000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=5000",
  //       },
  //       {
  //         value: "5000-10000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=5001&endprice=10000",
  //       },
  //       {
  //         value: "10000-25000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=10001&endprice=25000",
  //       },
  //       {
  //         value: "Above 25000",
  //         url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=25001&endprice=200000",
  //       },
  //     ],
  //   ],
  //   expand: true,
  // },
  // [
  //   { title: "MORE CATEGORIES", value: "MORE CATEGORIES", url: "#" },
  //   { title: "Hair Ornaments", value: "Hair Ornaments", url: "#" },
  //   { title: "Idols & Articles", value: "Idols & Articles", url: "#" },
  //   { title: "Maang Tikka", value: "Maang Tikka", url: "#" },
  //   { title: "Oddiyanam", value: "Oddiyanam", url: "#" },
  //   { title: "Bracelet", value: "Bracelet", url: "#" },
  //   { title: "Armlets", value: "Armlets", url: "#" },
  //   { title: "Anklets", value: "Anklets", url: "#" },
  //   { title: "Nosepin", value: "Nosepin", url: "#" },
  //   { title: "Other Accessories", value: "Other Accessories", url: "#" }
  // ]
  //wedding collections

  {
    title: "Others Categories",
    key: "5",
    url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
    Submenu: [
      [
        {
          value: null,
          title: "OTHERS",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          subitems:[
            {
          value: "Pendant",
          title: null,
          url: "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
          class: "allneck",
        },
        {
          value: "Ring",
          title: null,
          isLink: true,
          url: "/rings-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Maang Tikka",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-maang+tikka-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Oddiyanam",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-oddiyanam-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Armlet",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-armlet-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Hair Ornaments",
          title: null,
          isLink: true,
          url: "/bridal+accessories-silver-hair+ornaments-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Nosepin",
          title: null,
          isLink: true,
          url: "/nose+pin+online-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Anklets",
          title: null,
          isLink: true,
          url: "/anklet-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Idols",
          title: null,
          isLink: true,
          url: "/idols-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Mens Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-from+mens+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Others",
          title: null,
          isLink: true,
          url: "/others-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        }
          ]
        },
        
      ],
      //Gifting
      [
        {
          title: "GIFTING",
          value: null,
          isLink: false,
          // url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
          subitems:[
        {
          title: null,
          value: "Under 1499",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=1500",
          class: "allneck",
        },
        {
          title: null,
          isLink: true,
          value: "Under 2499",
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=1500&endprice=2500",
        },
        {
          title: null,
          value: "Under 4999",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=2500&endprice=5000",
        },
        // {"title":"Dmudra","value":"Dmudra","url":"/silver-jewellery-dmudra?sort=New%20to%20Stylori&startprice=0&endprice=0"},
        {
          title: null,
          value: "Under 9999",
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=5000&endprice=10000",
        },]
        },
        
      ],
      //finish
      [
        {
          value: null,
          title: "FINISH",
          // url: "/silver-necklaces-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: false,
          subitems:[{
          value: "CZ/Swarovski Jewellery",
          title: null,
          isLink: true,
          url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Beads & Pearl Jewellery",
          title: null,
          url: "/silver-jewellery-beads+pearl+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Deep Nagas & Kundan",
          title: null,
          url: "/silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Gold Plated Kundan",
          title: null,
          url: "/silver-jewellery-gold+plated+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
          isLink: true,
        },
        {
          value: "Studded Jewellery",
          title: null,
          isLink: true,
          url: "/silver-jewellery-studded+jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   value: "Gold Plated kemp",
        //   title: "Gold Plated kemp",
        //   url: "/silver-necklaces-jewellery-gold+plated+kemp?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // },
        {
          value: "Nagas/Nakshi",
          title: null,
          isLink: true,
          url: "/silver-jewellery-nagas+nakshi?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Dual Tone",
          isLink: true,
          title: null,
          url: "/silver-jewellery-dual+tone+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Victorian",
          isLink: true,
          title: null,
          url: "/silver-jewellery-victorian-finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Oxidised",
          isLink: true,
          title: null,
          url: "/silver-jewellery-oxidised+finish?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Others",
          title: null,
          isLink: true,
          url: "/silver-jewellery-finish+others?sort=New%20to%20Stylori&startprice=0&endprice=0",
        }],
          class: "allneck",
        },
        
      ],
    ],
    expand: true,
  },
  // {
  //   title: "Style",
  //   key: "6",
  //   isLink: true,
  //   url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //   Submenu: [
  //     [
  //       {
  //         title: "Style",
  //         value: null,
  //         isLink: true,
  //         url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Traditional",
  //         isLink: true,
  //         url: "/silver-jewellery-traditional?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         isLink: true,
  //         value: "Folklore",
  //         url: "/silver-jewellery-folklore?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Contemporary",
  //         isLink: true,
  //         url: "/silver-jewellery-contemporary?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       // {"title":"Dmudra","value":"Dmudra","url":"/silver-jewellery-dmudra?sort=New%20to%20Stylori&startprice=0&endprice=0"},
  //       {
  //         title: null,
  //         value: "Everyday",
  //         isLink: true,
  //         url: "/silver-jewellery-everyday?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //   ],
  //   expand: true,
  // },
  // {
  //   title: "Shop By Collection",
  //   key: "7",
  //   url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //   Submenu: [
  //     [
  //       {
  //         title: "SHOP BY COLLECTION",
  //         value: null,
  //         url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Rasvini",
  //         url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //         class: "allneck",
  //       },
  //       {
  //         title: null,
  //         value: "Mural",
  //         url: "/silver-jewellery-mural+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Starstuck",
  //         url: "/silver-jewellery-starstruck+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Concentric",
  //         url: "/silver-jewellery-concentric+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "IN LOVE COLLECTION",
  //         url: "/silver-jewellery-inlovecollection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Elemental",
  //         url: "/silver-jewellery-elemental+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Baroque Whites",
  //         url: "/silver-jewellery-baroque+whites+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //       {
  //         title: null,
  //         value: "Akruti",
  //         url: "/silver-jewellery-akruti+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
  //       },
  //     ],
  //   ],
  //   expand: true,
  // },
  {
    title: "Hot Sale",
    key: "7",
    isLink: true,
    url: "/silver-special+offer+sale-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",

    expand: false,
  },
  // {
  //   title: "Stylori",
  //   key: "8",
  //   url: "/",
  //   expand: false
  // }
  {
    title: "Collection",
    key: "8",
    isLink: true,
    url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    // bigImage: "https://styloriimages.s3.ap-south-1.amazonaws.com/Banners/Stylori+Silver/Menu-Dropdown-Images---Earrings.jpg",
    Submenu: [
      [
        // {
        //   value: null,
        //   title: "COLLECTION",
        //   isLink: true,
        //   url: "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        //   class: "allneck",
        // },
        {
          value: "Avarna",
          title: null,
          isLink: false,
          url: "/silver-jewellery-avarna?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },        
        {
          value: "Zelura",
          title: null,
          isLink: false,
          url: "/silver-jewellery-zelura?sort=New%20to%20Stylori&startprice=0&endprice=0",
          class: "allneck",
        },
        {
          value: "Rasvini",
          isLink: false,
          title: null,
          url: "/silver-rasvini-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "InLove",
          title: null,
          isLink: false,
          url: "/silver-jewellery-inlovecollection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Victorian",
          title: null,
          isLink: false,
          url: "/silver-jewellery-victorian-collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Mural Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-mural+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Elemental Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-elemental+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        {
          value: "Akruti Collection",
          title: null,
          isLink: false,
          url: "/silver-jewellery-akruti+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        },
        // {
        //   value: "Mens Collection",
        //   title: null,
        //   isLink: false,
        //   url: "/silver-jewellery-from+mens+collection?sort=New%20to%20Stylori&startprice=0&endprice=0",
        // },
        // {
        //   value: "Bridal",
        //   title: null,
        //   isLink: false,
        //   url: "/silver-jewellery-for+wedding?sort=New%20to%20Stylori&startprice=0&endprice=0"
        // },
      ],
    ],
    expand: true,
  },
];
const homePageVideoData = [
  {
    title: "Carlona Studs",
    price: "2,990",
    salesprice: "2,691",
    image: constants.DEFAULT_IMAGE + "/video_img1.png",
    circle_image: constants.DEFAULT_IMAGE + "/video_circleimg1.png",
  },
  {
    title: "Product Number 01",
    price: "2,990",
    salesprice: "2,691",
    image: constants.DEFAULT_IMAGE + "/video_img2.png",
    circle_image: constants.DEFAULT_IMAGE + "/video_circleimg2.png",
  },
  {
    title: "Product Number 02",
    price: "2,990",
    salesprice: "2,691",
    image: constants.DEFAULT_IMAGE + "/video_img3.png",
    circle_image: constants.DEFAULT_IMAGE + "/video_circleimg3.png",
  },
  {
    title: "Product Number 03",
    price: "2,990",
    salesprice: "2,691",
    image: constants.DEFAULT_IMAGE + "/video_img4.png",
    circle_image: constants.DEFAULT_IMAGE + "/video_circleimg4.png",
  },
  {
    title: "Product Number 04",
    price: "2,990",
    salesprice: "2,691",
    image: constants.DEFAULT_IMAGE + "/video_img5.png",
    circle_image: constants.DEFAULT_IMAGE + "/video_circleimg5.png",
  },
  {
    title: "Product Number 05",
    price: "2,990",
    salesprice: "2,691",
    image: constants.DEFAULT_IMAGE + "/video_img6.png",
    circle_image: constants.DEFAULT_IMAGE + "/video_circleimg6.png",
  },
];
const homePageProductCountCard = [
  {
    title: "Gold Pendants",
    subtitle: "pendants",

    image: constants.DEFAULT_IMAGE + "/productcountcard_img1.png",
    hoverimg: constants.DEFAULT_IMAGE + "/productcountcard_hoverimg1.png",
  },
  {
    title: "Diamond Ring",
    subtitle: "rings",

    image: constants.DEFAULT_IMAGE + "/productcountcard_img2.png",
    hoverimg: constants.DEFAULT_IMAGE + "/productcountcard_hoverimg2.png",
  },
  {
    title: "Gold Earings",
    subtitle: "earrings",

    image: constants.DEFAULT_IMAGE + "/productcountcard_img3.png",
    hoverimg: constants.DEFAULT_IMAGE + "/productcountcard_hoverimg3.png",
  },
  {
    title: "Designer Bangle",
    subtitle: "bangles",

    image: constants.DEFAULT_IMAGE + "/productcountcard_img4.png",
    hoverimg: constants.DEFAULT_IMAGE + "/productcountcard_hoverimg4.png",
  },
];
export const getHomepagedata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_HOME_DATA_REQUEST });

  try {
    const data = await homeResponse();

    // config.logGeneral && console.log("homepagedata", data)
    dispatch({
      type: ACTION_TYPE.GET_HOME_DATA_RESPONSE_SUCCESS,

      payload: {
        homeResponseSuccess: data,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("ErroringetHomepagedata", error);
    dispatch({
      type: ACTION_TYPE.GET_HOME_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getSubscriptionData = () => async (dispatch) => {
  config.logGeneral && console.log("getSubscriptionDatacal");
  // dispatch({ type: ACTION_TYPE.SUBSCRIPTION_DATA_REQUEST });

  try {
    // Calculate the current time plus 30 minutes
    const currentTime = Date.now();
    const subscribeTime = currentTime + 30 * 60 * 1000;

    // Dispatch success action with the updated subscribeTime
    dispatch({
      type: ACTION_TYPE.SUBSCRIPTION_DATA_SUCCESS,
      payload: {
        subscribeTime: subscribeTime,
      },
    });
  } catch (error) {
    // Log the error if needed
    console.log("Error in getSubscriptionData", error);

    // Dispatch failure action
    dispatch({
      type: ACTION_TYPE.SUBSCRIPTION_DATA_FAILURE,
    });
  }
};
export const getHomePageMainBannerdata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_HOME_MAIN_BANNER_DATA_REQUEST });

  try {
    const data = await homeResponse();

    config.logGeneral && console.log("getHomePageMainBannerdata", data);

    dispatch({
      type: ACTION_TYPE.GET_HOME_MAIN_BANNER_DATA_RESPONSE_SUCCESS,

      payload: {
        homeMainBannerResponseSuccess: createHomeDataResponseObject(
          data,
          constants.HomePageBanner,
          null
        ),
      },
    });
  } catch (error) {
    Config.logGeneral &&
      config.logGeneral &&
      console.log("ErroringgetHomePageMainBannerdata", error);
    dispatch({
      type: ACTION_TYPE.GET_HOME_MAIN_BANNER_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getHomePageSubBannerdata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_HOME_SUB_BANNER_DATA_REQUEST });

  try {
    const data = await homeResponse();

    dispatch({
      type: ACTION_TYPE.GET_HOME_SUB_BANNER_DATA_RESPONSE_SUCCESS,

      payload: {
        homeSubBannerResponseSuccess: createHomeDataResponseObject(
          data,
          constants.StyloriCard,
          null
        ),
      },
    });
  } catch (error) {
    Config.logGeneral &&
      config.logGeneral &&
      console.log("ErroringetgetHomePageSubBannerdata", error);
    dispatch({
      type: ACTION_TYPE.GET_HOME_SUB_BANNER_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getBestSellerdata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_BESTSELLER_DATA_REQUEST });

  try {
    const data = await homeResponse();

    // const filterdData = data?.findIndex(
    //   (obj) =>
    //     obj?.component === constants.StyloriTitle &&
    //     obj?.props?.title_Text === constants.BESTSELLERS
    // );

    // const bestSellerDataArray = data[filterdData + 1]?.props;
    // const bestSellerHeader = data[filterdData]?.props?.title_Text;
    // const bestSellerData = {
    //   component: bestSellerHeader,
    //   props: bestSellerDataArray,
    // };

    // config.logGeneral && console.log("homepagedata", data)

    dispatch({
      type: ACTION_TYPE.GET_BESTSELLER_DATA_RESPONSE_SUCCESS,

      payload: {
        bestSellerResponseSuccess: createHomeDataResponseObject(
          data,
          constants.StyloriTitle,
          constants.BestSellers,
          constants.bestSeller_data
        ),
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Erroringetbestseller", error);
    dispatch({
      type: ACTION_TYPE.GET_BESTSELLER_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const countryselect = (countrydata) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.SELECTEDCOUNTRY_REQUEST });
  try {
    dispatch({
      type: ACTION_TYPE.SELECTEDCOUNTRY_SUCCESS,
      payload: { countryselectedvalues: countrydata },
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPE.SELECTEDCOUNTRY_FAIL,
      errorMessage: "No country selected!!",
    });
  }
};

export const getShopbyfinishdata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_SHOPBYFINISH_COLLECTION_DATA_REQUEST });

  try {
    const data = await homeResponse();

    // config.logGeneral && console.log("homepagedata", data)
    dispatch({
      type: ACTION_TYPE.GET_SHOPBYFINISH_COLLECTION_DATA_RESPONSE_SUCCESS,
      payload: {
        shopbyfinishCollectionResponseSuccess: createHomeDataResponseObject(
          data,
          constants.StyloriTitle,
          constants.ShopbyFinish,
          constants.ShopbyFinish_data
        ),
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Erroringetnavarathnaa", error);
    dispatch({
      type: ACTION_TYPE.GET_SHOPBYFINISH_COLLECTION_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getReadourblogsdata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_READ_OUR_BLOGS_DATA_REQUEST });

  try {
    const data = await homeResponse();

    // config.logGeneral && console.log("homepagedata", data)
    dispatch({
      type: ACTION_TYPE.GET_READ_OUR_BLOGS_DATA_RESPONSE_SUCCESS,

      payload: {
        readOurBlogsDataResponseSuccess: createHomeDataResponseObject(
          data,
          constants.BlogPageCard,
          null
        ),
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Erroringetreadourblogsdata", error);
    dispatch({
      type: ACTION_TYPE.GET_READ_OUR_BLOGS_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

export const gettestimonialdata = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_TESTIMONIAL_DATA_REQUEST });

  try {
    const data = await homeResponse();

    config.logGeneral && console.log("homepagedatatestvvv", data);
    dispatch({
      type: ACTION_TYPE.GET_TESTIMONIAL_DATA_RESPONSE_SUCCESS,

      payload: {
        gettestimonialdataResponseSuccess: createHomeDataResponseObject(
          data,
          constants.testimonial,
          null
        ),
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Erroringettestimonialdata", error);
    dispatch({
      type: ACTION_TYPE.GET_TESTIMONIAL_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

export const getHomepagenotification = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_HOME_NOTIFICATION_REQUEST });

  try {
    const data = await homeNotification();

    config.logGeneral && console.log("homenotificationpagedata", data);
    dispatch({
      type: ACTION_TYPE.GET_HOME_NOTIFICATION_RESPONSE_SUCCESS,

      payload: {
        homenotificationResponseSuccess: data,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error", error);
    dispatch({
      type: ACTION_TYPE.GET_HOME_NOTIFICATION_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
const getRandomItems = (array, numItems) => {
  let result = [];
  let seenIndexes = new Set();

  while (result.length < numItems) {
    const randomIndex = Math.floor(Math.random() * array.length);
    if (!seenIndexes.has(randomIndex)) {
      result.push(array[randomIndex]);
      seenIndexes.add(randomIndex);
    }
  }

  return result;
};
export const searchquerymenu = (searchtext) => async (dispatch) => {
  Config.logGeneral &&
    config.logGeneral &&
    console.log("search text result in searchtext menu", searchtext);
  var srchtxt = `%${searchtext}%`;
  Config.logGeneral &&
    config.logGeneral &&
    console.log("search text result in searchtext menu searchtext", srchtxt);
  dispatch({ type: ACTION_TYPE.SEARCHMENU_REQUEST });

  try {
    const data = await filter_product_suggestion(srchtxt);
    // const randomItems = getRandomItems(data, 4);
    Config.logGeneral &&
      config.logGeneral &&
      console.log(
        "search text result in menu",
        data?.data?.data?.allTransSkuLists?.nodes
      );
    var randomItems = data?.data?.data?.allTransSkuLists?.nodes || [];
    if (randomItems.length > 4) {
      randomItems = getRandomItems(randomItems, 4);
    }
    config.logGeneral && console.log(randomItems, "randomItemsbbb");
    dispatch({
      type: ACTION_TYPE.SEARCHMENU_SUCCESS,

      payload: {
        searchdatainmenu: randomItems,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error", error);
    dispatch({
      type: ACTION_TYPE.SEARCHMENU_FAIL,
      errorMessage: error?.response?.data?.message,
    });
  }
};

export const getHeaderdata = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_HEADER_DATA_REQUEST });

  try {
    // const  data  = await login(form_data);

    // config.logGeneral && console.log("homepagedata", data)
    dispatch({
      type: ACTION_TYPE.GET_HEADER_DATA_REQUEST_SUCCESS,

      payload: {
        headerResponseSuccess: menuListHeaderNew1,
        headerResponseSuccessMobile: menuListHeaderNew1mobile,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error in getHomepagedata", error);
    dispatch({
      type: ACTION_TYPE.GET_HEADER_DATA_REQUEST_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getVideodata = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_VIDEO_DATA_REQUEST });

  try {
    // const  data  = await login(form_data);

    // config.logGeneral && console.log("homepagedata", data)
    dispatch({
      type: ACTION_TYPE.GET_VIDEO_DATA_RESPONSE_SUCCESS,

      payload: {
        videoDataResponseSuccess: homePageVideoData,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error in getHomepagedata", error);
    dispatch({
      type: ACTION_TYPE.GET_VIDEO_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getProductCountCard = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PRODUCT_COUNT_CARD_DATA_REQUEST });

  try {
    const data = await home_product_type_count();

    Config.logGeneral &&
      config.logGeneral &&
      console.log(
        "productCountDatacheck",
        createHomeProductCountObject(homePageProductCountCard, data)
        // "data?.data",
        // data?.data
      );

    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_COUNT_CARD_DATA_SUCCESS,

      payload: {
        productsCountCardDataResponseSuccess: createHomeProductCountObject(
          homePageProductCountCard,
          data
        ),
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error in getHomepagedata", error);
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_COUNT_CARD_DATA_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
//MAIL SUBSCRIPTION
export const subscribeUserWithMail = (email) => async (dispatch) => {
  const registered_email = store.getState().authReducer.userProfile_email;
  dispatch({ type: ACTION_TYPE.MAIL_SUBSCRIPTION_REQUEST });

  try {
    // Call the subscribeUser function, which returns a Promise
    const message = await subscribeUser(email);
    // Dispatch success action if subscription is successful
    dispatch({
      type: ACTION_TYPE.MAIL_SUBSCRIPTION_RESPONSE_SUCCESS,
      payload: message, // Pass the success message from the API response
    });
    dispatch({
      type: ACTION_TYPE.CLOSE_MODAL_SUBSCRIBE,
    });
    if (registered_email === email) {
      dispatch({
        type: ACTION_TYPE.REGISTERD_EMAIL_SUBSCRIPTION_SUCCESS,
      });
    }
    if(message === "Your email ID already subscribed with us"){
      Toast("Your email ID already subscribed with us!", "error");      
    }else{
      Toast("Email Subscription Successful!", "success");
    }
    
  } catch (error) {
    // Dispatch failure action with the error message
    Toast(error, "error");
    if (error === "Your email ID already subscribed with us") {
      dispatch({
        type: ACTION_TYPE.MAIL_SUBSCRIPTION_RESPONSE_SUCCESS,
        payload: error, // Pass the success message from the API response
      });
      dispatch({
        type: ACTION_TYPE.CLOSE_MODAL_SUBSCRIBE,
      });
    } else {
      dispatch({
        type: ACTION_TYPE.MAIL_SUBSCRIPTION_RESPONSE_FAILURE,
        errorMessage: error, // The error message from the rejection
      });
    }
  }
};
//MAIL SUBSCRIPTION clear
export const clearMessage = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.MAIL_SUBSCRIPTION_RESPONSE_SUCCESS_CLEAR });
};
//contact us form submit
export const contactus_form_submission = (form_data) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.CONTACTUSFORM_REQUEST });

  try {
    const data = await submitContactForm(form_data);
    // Check if the API response is successful
    if (
      data &&
      data.message === "Thanks for contacting us. Our Team will reach out you."
    ) {
      dispatch({
        type: ACTION_TYPE.CONTACTUSFORM_SUCCESS,
        payload: "Thanks for contacting us. Our Team will reach out you.",
      });
    } else {
      // Handle failure case if the message from the API is not success
      dispatch({
        type: ACTION_TYPE.CONTACTUSFORM_FAIL,
        errorMessage:
          data.message || "Failed to submit the form. Please try again later.",
      });
    }
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.CONTACTUSFORM_FAIL,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};
//TO GET DAILY METAL PRICE AND CURRENCY
export const daily_metal_price_currency = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.DAILYMETALANDCURRENCY_REQUEST });

  try {
    const data = await dailyMetalPriceAndCurrency();
    config.logGeneral &&
      console.log(data, " daily metal price and currency info....");
    dispatch({
      type: ACTION_TYPE.DAILYMETALANDCURRENCY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.DAILYMETALANDCURRENCY_FAIL,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};
export const instgramLinks = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.INSTAGRAM_LINK_REQUEST });

  try {
    const data = await homeResponse();
    // homeMainBannerResponseSuccess: createHomeDataResponseObject(
    //   data,
    //   constants.HomePageBanner,
    //   null
    // ),

    dispatch({
      type: ACTION_TYPE.INSTAGRAM_LINK_REQUEST_SUCCESS,
      payload: {
        instagramLinkResponseSuccess: instagramResponseObject(
          data,
          constants.InstagramPost,
          null
        ),
      },
    });
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.INSTAGRAM_LINK_REQUEST_FAILURE,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};
//to reset contact us form submission
export const resetContactUsStatus = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.CONTACTUSFORM_RESET });
};
// pagename may be 'termsconditions','privacyPolicy','faqs'
export const getFaqData = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.FAQ_DATA_REQUEST });

  try {
    const data = await cdnresponse("faqs");
    // Check if the API response is successful
    config.logGeneral && console.log("getFaqData1234", data);

    dispatch({
      type: ACTION_TYPE.FAQ_DATA_REQUEST_SUCCESS,
      payload: { faqDataResponseSuccess: data },
    });
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.FAQ_DATA_REQUEST_FAILURE,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};
export const getPrivacyPolicy = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.PRIVACY_POLICY_DATA_REQUEST });

  try {
    const data = await cdnresponse("privacyPolicy");
    // Check if the API response is successful

    dispatch({
      type: ACTION_TYPE.PRIVACY_POLICY_DATA_REQUEST_SUCCESS,
      payload: { privacyPolicyDataResponseSuccess: data },
    });
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.PRIVACY_POLICY_DATA_REQUEST_FAILURE,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};
export const getTermsOfUse = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.TERMS_OF_USE_DATA_REQUEST });

  try {
    const data = await cdnresponse("termsconditions");
    // Check if the API response is successful
    config.logGeneral && console.log("termsconditionsrespo ", data);

    dispatch({
      type: ACTION_TYPE.TERMS_OF_USE_DATA_REQUEST_SUCCESS,
      payload: { termsofUseDataResponseSuccess: data },
    });
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.TERMS_OF_USE_DATA_REQUEST_FAILURE,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};
export const starSpotting = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.STARSPOTTING_DATA_REQUEST });

  try {
    const data = await homeResponse();
    // homeMainBannerResponseSuccess: createHomeDataResponseObject(
    //   data,
    //   constants.HomePageBanner,
    //   null
    // ),

    dispatch({
      type: ACTION_TYPE.STARSPOTTING_DATA_REQUEST_SUCCESS,
      payload: {
        starSpottingResponseSuccess: createHomeDataResponseObject(
          data,
          constants.StyloriTitle,
          constants.Starspotting
        ),
      },
    });
  } catch (error) {
    // If any unexpected error occurs
    dispatch({
      type: ACTION_TYPE.STARSPOTTING_DATA_REQUEST_FAILURE,
      errorMessage:
        error?.message || "An error occurred. Please try again later.",
    });
  }
};


